import { get, values } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getSettingsPortalUser = get('settings.portal.user');

export const getAll = createSelector(getSettingsPortalUser, get('all'));

export const getAllValues = createSelector(getAll, values);

export const getOrder = createSelector(getSettingsPortalUser, get('order'));

export const getIsFetching = createSelector(
  getSettingsPortalUser,
  get('fetching')
);
export const getIsFetched = createSelector(
  getSettingsPortalUser,
  get('fetched')
);

export const getFetchingError = createSelector(
  getSettingsPortalUser,
  get('fetchingError')
);

export const getIsSaving = createSelector(getSettingsPortalUser, get('saving'));

export const getIsSaved = createSelector(getSettingsPortalUser, get('saved'));
